<template>
  <div class="main-panel">
    <div class="nav-bar-operations">
      <img
        src="@/assets/logogruas.png"
        alt="HomePage"
        class="logo-button"
        @click="backMainPanel"
      />
    </div>

    <header class="header">
      <div class="header__left">
        <div class="avatar" aria-hidden="true">RH</div>
        <div class="greet">
          <h1>Bienvenido/a a <span>RRHH</span></h1>
          <p class="sub">Selecciona una opción para continuar</p>
        </div>
      </div>
    </header>

    <section class="grid">
      <article
        v-for="tile in visibleTiles"
        :key="tile.key"
        class="card"
        role="link"
        tabindex="0"
        @click="go(tile.to)"
        @keyup.enter="go(tile.to)"
      >
        <div class="card__media">
          <img :src="tile.img" :alt="tile.title" />
        </div>
        <div class="card__content">
          <div class="card__title">
            <h2>{{ tile.title }}</h2>
            <span class="chip" v-if="tile.chip">{{ tile.chip }}</span>
          </div>
          <ul class="card__list">
            <li v-for="(p, i) in tile.points" :key="i">{{ p }}</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" :to="tile.to">Entrar</router-link>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'RHModule',
  data() {
    return {
      permissions: [],
      tiles: [
        {
          key: 'personal',
          title: 'Personal',
          img: require('@/assets/personal-card.jpg'),
          points: ['Tabla del personal', 'Perfil detallado de colaboradores'],
          to: { path: '/modulo-personal/personal' },
          chip: 'Core',
          requiredPerms: ['ui_access_rrhh_personal_card', 'ui_access_rrhh_module'],
        },
        {
          key: 'attendance',
          title: 'Asistencia',
          img: require('@/assets/hr-attendance-card.jpg'),
          points: ['Registro diario por empleado', 'Control de asistencia mensual'],
          to: { path: '/modulo-personal/asistencia' },
          chip: 'Nuevo',
          requiredPerms: ['ui_access_rrhh_attendance', 'ui_access_rrhh_module'],
        },
        {
          key: 'incidents',
          title: 'Incidencias',
          img: require('@/assets/hr-incidents-card.jpg'),
          points: ['Maestro de incidencias', 'Búsqueda por nivel, tipo y empleado'],
          to: { path: '/modulo-personal/incidencias' },
          chip: 'Nuevo',
          requiredPerms: ['ui_access_rrhh_incidents_card', 'ui_access_rrhh_module'],
        },
        {
          key: 'incidents-dashboard',
          title: 'Tablero de incidencias',
          img: require('@/assets/hr-incidents-board-card.jpg'),
          points: ['Matriz mensual por empleado', 'Acumulado de incidencias por departamento'],
          to: { path: '/modulo-personal/tablero-incidencias' },
          chip: 'Nuevo',
          requiredPerms: ['ui_access_rrhh_incidents_dashboard', 'ui_access_rrhh_module'],
        },
        {
          key: 'receipts',
          title: 'Recibos',
          img: require('@/assets/hr-receipts-card.jpg'),
          points: ['Maestro de recibos', 'Busqueda y captura de recibos por empleado'],
          to: { path: '/modulo-personal/recibos' },
          chip: 'Nuevo',
          requiredPerm: 'ui_access_rrhh_receipts',
        },
        {
          key: 'nomina',
          title: 'Nomina',
          img: require('@/assets/hr-payroll-card.jpg'),
          points: ['Importacion de archivos de nomina', 'Calculo de nomina semanal'],
          to: { path: '/modulo-personal/nomina' },
          chip: 'Nuevo',
          requiredPerms: ['ui_access_rrhh_nomina', 'ui_access_rrhh_module'],
        },
      ],
    }
  },
  computed: {
    visibleTiles() {
      return this.tiles.filter((tile) => {
        if (tile.requiredPerm) return this.hasPerm(tile.requiredPerm)
        if (tile.requiredPerms) return this.hasAllPerms(tile.requiredPerms)
        return false
      })
    },
  },
  created() {
    this.fetchCurrentUser()
  },
  methods: {
    hasPerm(permOrPerms) {
      if (!permOrPerms) return false
      const perms = Array.isArray(permOrPerms) ? permOrPerms : [permOrPerms]
      return perms.some((perm) => {
        if (this.permissions.includes(perm)) return true
        return this.permissions.includes(`access_control.${perm}`)
      })
    },
    hasAllPerms(perms) {
      return Array.isArray(perms) && perms.length > 0 && perms.every((perm) => this.hasPerm(perm))
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.permissions = data.permissions || []
        if (!this.hasPerm('ui_access_rrhh_module')) {
          this.$router.push({ name: 'MainPanel' })
        }
      } catch (error) {
        this.$router.push({ name: 'MainPanel' })
      }
    },
    backMainPanel() {
      this.$router.push({ path: '/main-panel' })
    },
    go(to) {
      this.$router.push(to)
    },
  },
}
</script>

<style scoped>
.main-panel {
  --bg: #ffffff;
  --panel: #151924;
  --muted: #373838;
  --text: #000000;
  --brand: #ffc434;
  --brand-ink: #3a2a00;
  --primary: #2563eb;
  --ring: rgba(37, 99, 235, 0.35);
}
@media (prefers-color-scheme: light) {
  .main-panel {
    --bg: #f7f8fb;
    --panel: #ffffff;
    --muted: #667085;
    --text: #0f172a;
    --brand: #ffc434;
    --brand-ink: #3a2a00;
    --primary: #2563eb;
    --ring: rgba(37, 99, 235, 0.25);
  }
}

.main-panel {
  min-height: 100vh;
  background: var(--bg);
  padding: 12vh 24px 48px;
}

.nav-bar-operations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  background-color: var(--brand);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding-left: 16px;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.05);
}
.logo-button {
  height: 55%;
  object-fit: contain;
  cursor: pointer;
}

.header {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.avatar {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, var(--brand), #ffe188);
  color: var(--brand-ink);
  font-weight: 800;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}
.greet h1 {
  font-size: 1.15rem;
  color: var(--text);
  margin: 0;
}
.greet h1 span {
  font-weight: 700;
}
.greet .sub {
  margin: 2px 0 0;
  color: var(--muted);
  font-size: 0.9rem;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px;
  margin-top: 10px;
}
.card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  outline: none;
  cursor: pointer;
}
.card:focus {
  box-shadow: 0 0 0 6px var(--ring);
}
.card:hover {
  transform: translateY(-3px);
  border-color: rgba(0, 0, 0, 0.12);
}

.card__media {
  position: relative;
  height: 140px;
  overflow: hidden;
}
.card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card__content {
  padding: 14px;
  display: grid;
  gap: 10px;
}
.card__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.card__title h2 {
  font-size: 1rem;
  margin: 0;
  color: #000;
}
.chip {
  font-size: 0.7rem;
  background: rgba(37, 99, 235, 0.15);
  color: #2563eb;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid rgba(37, 99, 235, 0.35);
}

.card__list {
  margin: 0;
  padding-left: 16px;
  color: #444;
}
.card__list li {
  margin: 3px 0;
}

.card__actions {
  display: flex;
  justify-content: flex-end;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid transparent;
  background: var(--panel);
  color: var(--text);
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.2s ease, background 0.2s ease, color 0.2s ease;
}
.btn:focus {
  outline: none;
  box-shadow: 0 0 0 6px var(--ring);
}

.btn--primary {
  background: var(--primary);
  color: white;
}
.btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 22px rgba(37, 99, 235, 0.35);
}

@media (max-width: 720px) {
  .header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
}

@media screen and (max-height: 586px) {
  .nav-bar-operations {
    height: 10vh;
  }
  .main-panel {
    padding-top: 12vh;
  }
}
@media screen and (min-height: 930px) {
  .main-panel {
    padding-top: 14vh;
  }
}
</style>